import React, { Component } from 'react'
import { FormControlLabel, Switch } from '@mui/material'
import { IFormInputBase } from '../types'

function CreateSwitchSimple<T>() {
  interface IProps extends IFormInputBase<T> {}

  interface IState {
    checked: boolean
  }

  return class SwitchSimple extends Component<IProps, IState> {
    constructor(props: IProps) {
      super(props)
      this.state = { checked: this.getChecked() }
    }

    render() {
      const { label, name } = this.props
      return (
        <FormControlLabel
          control={<Switch checked={this.state.checked} onChange={(_, checked) => this.setState({ checked })} />}
          label={label}
          name={name?.toString()}
        />
      )
    }

    getChecked = (): boolean => {
      const { data, name, defaultValue } = this.props
      if (!name) return false
      const dValue = data?.[name] || defaultValue
      return ['on', true].some((x) => x === dValue)
    }
  }
}

export default CreateSwitchSimple
